import { capitalizeWord } from "@hypexone/uicore";
import { getEnvVariable, WhitelabelEnvDTO } from "../../../constants/brandConfig";
import Button from "../shared/Button/Button";
import { domain } from "../../../constants/Branding";

const websiteUrls: WhitelabelEnvDTO["skins"] = getEnvVariable(domain, 'skins') || [];

const SkinOptions = () => {
  const handleSkinChange = (domain) => {
    localStorage.setItem("userSkin", domain);
    window.open(`http://${domain}/login?authToken=${sessionStorage.getItem("jwt_token")}`, "_self");
  };

  return (
    <div className="flex flex-col gap-1 py-1 pr-1">
      {websiteUrls?.map((skin) => (
        <Button
          key={skin.label}
          className={`${
            skin.disabled ? "" : ""
          } text-black text-sm px-2 py-[6px] text-center last:border-b-0 border-b cursor-pointer hover:underline`}
          onClick={() => handleSkinChange(skin.domain)}
          disabled={skin.disabled}
        >
          {"  "}
          {capitalizeWord(skin.label)}
        </Button>
      ))}
    </div>
  );
};

export default SkinOptions;
